export enum ProfileType {
  ALL = 'all',
  BWP_ONLY = 'bwp-only',
  BWP_ALL = 'bwp-all',
}
